var scrollPosition = function(obj, callback, offset = .75) {
	var scrollPosition = window.pageYOffset,
		windowHeight = window.innerHeight,
		objPosition = obj.offsetTop,
		objHeight = obj.offsetHeight,
		reset = true,
		objTop = objPosition - (windowHeight * offset),
		objBottom,
		startpoint,
		endpoint,
		slideshow = obj.classList.contains('coto_slideshow');

	if (objPosition < windowHeight) {
		objTop = 0;
	}

	objBottom = objPosition + objHeight - (windowHeight * .25);
	startpoint = scrollPosition >= objTop;
	endpoint = scrollPosition < objBottom;

	if (slideshow) {
		startpoint = startpoint && endpoint;
	}
	
	if (startpoint) {
		callback();
	} else {
		callback(reset);
	}
};

module.exports = scrollPosition;